import { _ as __rest } from '../tslib.es6-C8rd5pYo.mjs';
import { Spinner, Icon } from '@zapier/design-system';
import { clsx } from 'clsx';
import React, { forwardRef } from 'react';
import { Description } from '../Description/Description.es.js';
import { ErrorMessage } from '../ErrorMessage/ErrorMessage.es.js';
import { Label } from '../Label/Label.es.js';
import { useFilter } from 'react-aria';
import { ComboBox, Input, Popover, ListBox } from 'react-aria-components';
import { TypeaheadItem } from './TypeaheadItem.es.js';
import { TypeaheadRightSlot } from './TypeaheadRightSlot.es.js';

const comboBox = "_combo-box_103c5_1";
const inputWrapper = "_input-wrapper_103c5_7";
const iconLeftWrapper = "_icon-left-wrapper_103c5_11";
const input = "_input_103c5_7";
const inputNoLeftIcon = "_input-no-left-icon_103c5_64";
const popover = "_popover_103c5_71";
const customWidth = "_custom-width_103c5_77";
const listBox = "_list-box_103c5_81";
const styles = {
	comboBox: comboBox,
	inputWrapper: inputWrapper,
	iconLeftWrapper: iconLeftWrapper,
	input: input,
	inputNoLeftIcon: inputNoLeftIcon,
	popover: popover,
	customWidth: customWidth,
	listBox: listBox
};

const TypeaheadRoot = forwardRef((_a, ref) => {
  var _b;
  var { children, className, classNamePopOver, defaultItems, defaultSelectedKey, defaultInputValue, errorMessage, helpText, iconLeft = "navSearch", inputValue, isBusy = false, isDisabled = false, isInvalid = false, items, label, menuWidth, menuTrigger, onSelectionChange, placeholder, iconRight = null, selectedKey, size = "large" } = _a, props = __rest(_a, ["children", "className", "classNamePopOver", "defaultItems", "defaultSelectedKey", "defaultInputValue", "errorMessage", "helpText", "iconLeft", "inputValue", "isBusy", "isDisabled", "isInvalid", "items", "label", "menuWidth", "menuTrigger", "onSelectionChange", "placeholder", "iconRight", "selectedKey", "size"]);
  const { contains } = useFilter({ sensitivity: "base" });
  const defaultFilter = (_b = props.defaultFilter) !== null && _b !== void 0 ? _b : contains;
  return React.createElement(
    ComboBox,
    Object.assign({}, props, { className: clsx(className, styles.comboBox), defaultFilter, defaultItems, defaultSelectedKey, defaultInputValue, inputValue, isDisabled, isInvalid, items, menuTrigger, onSelectionChange, selectedKey, allowsEmptyCollection: true, "data-zds": true, shouldFocusWrap: true }),
    label && React.createElement(Label, { isCompact: size === "compact", isDisabled, isInvalid }, label),
    React.createElement(
      "div",
      { className: styles.inputWrapper, "data-zds": true },
      iconLeft && React.createElement("div", { className: styles.iconLeftWrapper, "data-size": size, "data-zds": true }, isBusy ? React.createElement(Spinner, null) : React.createElement(Icon, { name: iconLeft, size: size === "compact" ? "20px" : "24px" })),
      React.createElement(Input, { className: `${styles.input} ${iconLeft === null ? styles.inputNoLeftIcon : ""}`, "data-zds": true, "data-size": size, placeholder, ref }),
      React.createElement(TypeaheadRightSlot, { iconRight, size })
    ),
    isInvalid && errorMessage ? React.createElement(ErrorMessage, { isCompact: size === "compact" }, errorMessage) : helpText && React.createElement(Description, { isCompact: size === "compact" }, helpText),
    React.createElement(
      Popover,
      { className: `${styles.popover} ${menuWidth ? styles.customWidth : ""} ${classNamePopOver !== null && classNamePopOver !== void 0 ? classNamePopOver : ""}`, "data-zds": true, offset: 5, style: menuWidth ? { "--menu-width": menuWidth } : void 0 },
      React.createElement(ListBox, { className: styles.listBox, "data-zds": true }, typeof children === "function" ? (item) => children(item) : children)
    )
  );
});
const Typeahead = Object.assign(TypeaheadRoot, {
  Item: TypeaheadItem
});

export { Typeahead, TypeaheadRoot };
//# sourceMappingURL=Typeahead.es.js.map
